import certificate       from '@/pages/certificate'
export default [
    {
        path: '/certificate', 
        name: 'certificate',
        component: certificate,
    }
    
]
